module.exports = __webpack_public_path__ + "static/person4-0a7484f4f3273ea18b395c1c33f65484.png";